import * as logger from 'ls-common-client/src/logger';
import config from '../config';

const instance = logger.create(config);

export default instance;
